module.exports = __webpack_public_path__ + "img/antes_despues_180.3f1c7d5e.png";